<script>
	import { getContext, onMount, createEventDispatcher } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../scripts/styles'

	const countries = [
		{ name: 'South Africa', value: '+27' },
		{ name: 'Switzerland', value: '+41' },
		{ name: 'Austria', value: '+43' },
		{ name: 'United Kingdom', value: '+44' },
		{ name: 'Germany', value: '+49' },
		{ name: 'USA', value: '+1' },
		{ name: 'Afghanistan', value: '+93' },
		{ name: 'Albania', value: '+355' },
		{ name: 'Algeria', value: '+213' },
		{ name: 'Andorra', value: '+376' },
		{ name: 'Angola', value: '+244' },
		{ name: 'Anguilla', value: '+809' },
		{ name: 'Antigua', value: '+268' },
		{ name: 'Argentina', value: '+54' },
		{ name: 'Armenia', value: '+374' },
		{ name: 'Australia', value: '+61' },
		{ name: 'Austria', value: '+43' },
		{ name: 'Azerbaijan', value: '+994' },
		{ name: 'Bahamas', value: '+242' },
		{ name: 'Bahrain', value: '+973' },
		{ name: 'Bangladesh', value: '+880' },
		{ name: 'Barbados', value: '+246' },
		{ name: 'Belarus', value: '+375' },
		{ name: 'Belgium', value: '+32' },
		{ name: 'Belize', value: '+501' },
		{ name: 'Benin', value: '+229' },
		{ name: 'Bermuda', value: '+809' },
		{ name: 'Bolivia', value: '+591' },
		{ name: 'Bosnia and Hercegovina', value: '+387' },
		{ name: 'Botswana', value: '+267' },
		{ name: 'Brazil', value: '+55' },
		{ name: 'Bulgaria', value: '+359' },
		{ name: 'BurkinaFaso', value: '+226' },
		{ name: 'Burundi', value: '+257' },
		{ name: 'Cambodia', value: '+855' },
		{ name: 'Cameroon', value: '+237' },
		{ name: 'Canada', value: '+1' },
		{ name: 'CapeVerdi', value: '+238 Verdi' },
		{ name: 'Caribbean Nations', value: '+1' },
		{ name: 'CaymanIslands', value: '+345 Islands' },
		{ name: 'CentralAfricanRepublic', value: '+236 African Republic' },
		{ name: 'Chad', value: '+235' },
		{ name: 'Chile', value: '+56' },
		{ name: 'China', value: '+86' },
		{ name: 'Colombia', value: '+57' },
		{ name: 'Congo', value: '+242' },
		{ name: 'CostaRica', value: '+506' },
		{ name: 'Croatia', value: '+385' },
		{ name: 'Cuba', value: '+53' },
		{ name: 'Cyprus', value: '+357' },
		{ name: 'CzechRepublic', value: '+420' },
		{ name: 'Denmark', value: '+45' },
		{ name: 'Ecuador', value: '+593' },
		{ name: 'Egypt', value: '+20' },
		{ name: 'ElSalvador', value: '+503' },
		{ name: 'EquatorialGuinea', value: '+240' },
		{ name: 'Eritrea', value: '+291' },
		{ name: 'Estonia', value: '+372' },
		{ name: 'Ethiopia', value: '+251' },
		{ name: 'Finland', value: '+358' },
		{ name: 'France', value: '+33' },
		{ name: 'Gabon', value: '+241' },
		{ name: 'Gambia', value: '+220' },
		{ name: 'Georgia', value: '+995' },
		{ name: 'Germany', value: '+49' },
		{ name: 'Ghana', value: '+233' },
		{ name: 'Gibraltar', value: '+350' },
		{ name: 'Greece', value: '+30' },
		{ name: 'Greenland', value: '+299' },
		{ name: 'Honduras', value: '+504' },
		{ name: 'HongKong', value: '+852' },
		{ name: 'Hungary', value: '+36' },
		{ name: 'Iceland', value: '+354' },
		{ name: 'India', value: '+91' },
		{ name: 'Indonesia', value: '+62' },
		{ name: 'Ireland', value: '+353' },
		{ name: 'Israel', value: '+972' },
		{ name: 'Italy', value: '+39' },
		{ name: 'IvoryCoast', value: '+225' },
		{ name: 'Jamaica', value: '+876' },
		{ name: 'Japan', value: '+81' },
		{ name: 'Kenya', value: '+254' },
		{ name: 'Latvia', value: '+371' },
		{ name: 'Lebanon', value: '+961' },
		{ name: 'Lesotho', value: '+266' },
		{ name: 'Libya', value: '+218' },
		{ name: 'Liechtenstein', value: '+423' },
		{ name: 'Lithuania', value: '+370' },
		{ name: 'Luxembourg', value: '+352' },
		{ name: 'Macao', value: '+853' },
		{ name: 'Macedonia', value: '+389' },
		{ name: 'Madagascar', value: '+261' },
		{ name: 'Malawi', value: '+265' },
		{ name: 'Malaysia', value: '+60' },
		{ name: 'Maldives', value: '+960' },
		{ name: 'Mali', value: '+223' },
		{ name: 'Malta', value: '+356' },
		{ name: 'Martinique', value: '+596' },
		{ name: 'Mauritius', value: '+230' },
		{ name: 'Mexico', value: '+52' },
		{ name: 'Moldova', value: '+373' },
		{ name: 'Monaco', value: '+33' },
		{ name: 'Montserrat', value: '+473' },
		{ name: 'Morocco', value: '+212' },
		{ name: 'Mozambique', value: '+258' },
		{ name: 'Namibia', value: '+264' },
		{ name: 'NewCaledonia', value: '+687' },
		{ name: 'NewZealand', value: '+64' },
		{ name: 'Nicaragua', value: '+505' },
		{ name: 'Niger', value: '+227' },
		{ name: 'Nigeria', value: '+234' },
		{ name: 'Norway', value: '+47' },
		{ name: 'Panama', value: '+507' },
		{ name: 'Paraguay', value: '+595' },
		{ name: 'Peru', value: '+51' },
		{ name: 'Philippines', value: '+63' },
		{ name: 'Poland', value: '+48' },
		{ name: 'Portugal', value: '+351 and Azores' },
		{ name: 'PuertoRico', value: '+1787' },
		{ name: 'Reunion', value: '+262(France)' },
		{ name: 'Romania', value: '+40' },
		{ name: 'Russia', value: '+7' },
		{ name: 'Rwanda', value: '+250' },
		{ name: 'Saipan', value: '+670' },
		{ name: 'SanMarino', value: '+378' },
		{ name: 'Senegal', value: '+221' },
		{ name: 'SerbiaandMontenegro', value: '+381 and Montenegro' },
		{ name: 'Seychelles', value: '+248' },
		{ name: 'Singapore', value: '+65' },
		{ name: 'Slovakia', value: '+421' },
		{ name: 'Slovenia', value: '+386' },
		{ name: 'SouthKorea', value: '+82 Korea' },
		{ name: 'SouthAfrica', value: '+27' },
		{ name: 'Spain', value: '+34' },
		{ name: 'SriLanka', value: '+94' },
		{ name: 'Swaziland', value: '+268' },
		{ name: 'Sweden', value: '+46' },
		{ name: 'Switzerland', value: '+41' },
		{ name: 'Taiwan', value: '+886' },
		{ name: 'Tanzania and Zanzibar', value: '+255' },
		{ name: 'Thailand', value: '+66' },
		{ name: 'Togo', value: '+228' },
		{ name: 'Tunisia', value: '+216' },
		{ name: 'Turkey', value: '+90' },
		{ name: 'USA', value: '+1' },
		{ name: 'Uganda', value: '+256' },
		{ name: 'Ukraine', value: '+380' },
		{ name: 'UnitedKingdom', value: '+44' },
		{ name: 'Uruguay', value: '+598' },
		{ name: 'VaticanCity', value: '+39' },
		{ name: 'Venezuela', value: '+58' },
		{ name: 'Zaire', value: '+243' },
		{ name: 'Zambia', value: '+260' },
		{ name: 'Zimbabwe', value: '+263' },
	]

	const globals = getContext('globals')
	export let fsS = globals.fsS
	export let selectTitle = globals.selectTitle
	export let inputBorder = globals.inputBorder
	export let inputBg = globals.inputBg
	export let optionBg = globals.optionBg
	export let selectHover = globals.selectHover
	export let width = '100%'
	export let value = 'select'
	export let safe = false
	export let storage = false
	const cmd = 'country'

	const dispatch = createEventDispatcher()

	let visible = false

	const set_visible = () => {
		visible = visible === true ? false : true
	}

	const set_title = (country, code) => {
		if (safe) {
			let checkStorage = sessionStorage.getItem(storage)
			checkStorage = JSON.parse(checkStorage)
			checkStorage = { ...checkStorage, [cmd]: country, code: code }
			sessionStorage.setItem(storage, JSON.stringify(checkStorage))
		}

		dispatch('select', {
			cmd: 'country',
			value: country,
			code: code,
		})
		value = country
		set_visible(false)
	}

	//create the sticky form

	onMount(() => {
		//sticky values
		if (safe) {
			let checkValue = sessionStorage.getItem(storage)
			if (!checkValue) {
				sessionStorage.setItem(storage, null)
				return
			}
			if (checkValue !== 'null') {
				checkValue = JSON.parse(checkValue)
				if (checkValue[cmd]) value = checkValue[cmd]
			}
		}
	})
</script>

<main>
	<div class="title_container" use:styles={{ selectTitle, inputBorder, inputBg, width, fsS }}>
		<div class="title">{value}</div>

		<div
			class="caretContainer"
			use:styles={{ optionBg, selectHover }}
			on:click={() => set_visible(true)}
			on:keydown={() => set_visible(true)}
		>
			<div class="caret" />
		</div>
	</div>
	{#if visible}
		<div
			use:styles={{ fsS, optionBg, selectHover, width, inputBorder }}
			class="option_container"
			in:slide={{ duration: 1000 }}
			out:slide={{ duration: 1000 }}
		>
			{#each countries as country}
				<div
					on:click={() => set_title(country.name, country.value)}
					on:keydown={() => set_title(country.name, country.value)}
					use:styles={{ selectTitle, selectHover }}
					class="option"
				>
					{country.name}
				</div>
			{/each}
		</div>
	{/if}
</main>

<style>
	main {
		width: 100%;
	}

	.title_container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border: 1px solid var(--inputBorder);
		font-size: var(--fsS);
		background-color: var(--inputBg);
		color: var(--selectTitle);
		height: 40px;
		width: var(--width);
	}

	.title {
		width: 90%;
		padding: 5px;
	}

	.caretContainer {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 10%;
		height: 100%;
		background: var(--optionBg);
		cursor: pointer;
	}

	.caretContainer:hover {
		background-color: var(--selectHover);
	}

	.caret {
		width: 0;
		height: 0;
		border-left: clamp(1px, 1vw, 10px) solid transparent;
		border-right: clamp(1px, 1vw, 10px) solid transparent;
		border-top: clamp(1px, 1vw, 10px) solid hsl(0, 0%, 80%);
	}

	.option_container {
		padding: 10px;
		background-color: var(--optionBg);
		max-height: 200px;
		overflow-y: scroll;
		overflow-x: hidden;
		font-size: calc(var(--fsS) - 3px);
		width: var(--width);
		border-left: 1px solid var(--inputBorder);
		border-right: 1px solid var(--inputBorder);
		border-bottom: 1px solid var(--inputBorder);
	}

	.option {
		color: var(--selectTitle);
		cursor: pointer;
		padding: 3%;
	}

	.option:hover {
		background: var(--selectHover);
	}
</style>
